"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santi-cosma-e-damiano": {
    "1d9b2e5b": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "campanili": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3ba2e9e2": [{
      "hkey": "7945b023",
      "slug": "grunuovo-campomaggiore-san-luca",
      "name": "Grunuovo-Campomaggiore San Luca",
      "primary": true,
      "skipSearch": false
    }],
    "campomaggiore": [{
      "hkey": "7945b023",
      "slug": "grunuovo-campomaggiore-san-luca",
      "name": "Grunuovo-Campomaggiore San Luca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santi-cosma-e-damiano"
    }],
    "e69d17b3": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "ceracoli": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "826e76d3": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "cisterna": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf6a0ea4": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "ferrara": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4868fba8": [{
      "hkey": "7945b023",
      "slug": "grunuovo-campomaggiore-san-luca",
      "name": "Grunuovo-Campomaggiore San Luca",
      "primary": true,
      "skipSearch": false
    }],
    "grunuovo": [{
      "hkey": "7945b023",
      "slug": "grunuovo-campomaggiore-san-luca",
      "name": "Grunuovo-Campomaggiore San Luca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "076677cd": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "pantaniello": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8eaccea8": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "parchetto": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d6d009a": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "perusi": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1be729c": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2773d6af": [{
      "hkey": "7945b023",
      "slug": "grunuovo-campomaggiore-san-luca",
      "name": "Grunuovo-Campomaggiore San Luca",
      "primary": true,
      "skipSearch": false
    }],
    "san-luca": [{
      "hkey": "7945b023",
      "slug": "grunuovo-campomaggiore-san-luca",
      "name": "Grunuovo-Campomaggiore San Luca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "santi-cosma-e-damiano"
    }],
    "ddd00fac": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "torraccio": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "56d7c456": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "veterinella": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d98b9ae0": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "skipSearch": false
    }],
    "volpara": [{
      "hkey": "34fddb16",
      "slug": "santi-cosma-e-damiano",
      "name": "Santi Cosma e Damiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;